
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import About from "./Pages/About";
import Home from "./Pages/Home";

import Blog from "./Pages/Blog";
import Contact from "./Pages/Contact";



import TrialAccountPage from './Component/TrialAccountPage';
import PrivacyPolicy from "./Component/PrivacyPolicy";
import TermsAndConditions from "./Component/TermsAndConditions";
import AuthModal from "./Component/AuthModal";
import { AuthProvider } from "./contex/AuthContext";
import Dashboard from "./Dashboard/Dashboard";
// import PolicyDocument from "./Dashboard/Components/Privacy";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [pathname]);

  return null;
}

function AppContent() {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authForm, setAuthForm] = useState('login');

  const handleAuthSuccess = (success) => {
    if (success) {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user && (user.role === 'admin' || user.role === 'superadmin' || user.role === 'hr' || user.role === 'manager' || user.role === 'employee')) {
        window.location.href = '/dashboard';
      }
    }
  };

  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={
          <Home 
            openAuthModal={(form) => {
              setAuthForm(form);
              setShowAuthModal(true);
            }} 
          />
        } />
         <Route path="/aboutus" element={<About />} />
        {/* <Route path="/pricing" element={<Pricing />} /> */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
       
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>

      <AuthModal 
        isOpen={showAuthModal}
        onClose={handleAuthSuccess}
        initialForm={authForm}
      />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;